import { FormItem, Input, Select } from '@lmc/ui-kit'
import { serviceUserProfileConstants as supConstants } from 'locale/serviceUserProfile'
import { useTranslation } from 'react-i18next'
import { NAMESPACE } from 'locale'
import {
  ImportantContactType,
  ResidentBody,
  ResidentItem,
  roleOptions,
} from '@lmc/ts-common'
import { UpdateResidentReturnType } from 'hooks/useResident'
import { ImportantContactBodyDtos } from '@lmc/ts-common/lib/dtos/Resident'
import BaseContactForm, { BaseFormType } from './BaseContactForm'
import getOptionsWithOneMoreValue from './utils/getOptionsWithOneMoreValue'
import { useMemo } from 'react'
import { Text } from '@lmc/ui-kit/src/general'

export type FormType = BaseFormType &
  Pick<ImportantContactBodyDtos, 'organisation' | 'speciality'>

type PersonalContactFormProps = {
  onSubmit: (values: Partial<ResidentBody>) => Promise<UpdateResidentReturnType>
  resident: ResidentItem | undefined
  isLoading: boolean
  editedIndex: number | undefined
}

const PersonalContactForm = ({
  onSubmit,
  resident,
  isLoading,
  editedIndex,
}: PersonalContactFormProps) => {
  const { t } = useTranslation(NAMESPACE.SERVICE_USER_PROFILE)

  const getNewContact = (values: FormType): ImportantContactBodyDtos => {
    const newContact: ImportantContactBodyDtos = {
      lpa: false,
      ...values,
      type: ImportantContactType.professional,
      name: {
        first: values.firstName,
        last: values.lastName,
      },
    }

    return newContact
  }

  const residentName =
    resident?.name?.first &&
    resident?.name.last &&
    `${resident.name.first} ${resident.name.last}'s`

  const editedContact =
    editedIndex !== undefined
      ? resident?.importantContacts[editedIndex]
      : undefined

  const options = useMemo(
    () => getOptionsWithOneMoreValue(roleOptions, editedContact?.relationship),
    [editedContact?.relationship]
  )
  const sortedOptions = options.sort((a, b) => (a.label > b.label ? 1 : -1))

  return (
    <BaseContactForm<FormType>
      onSubmit={onSubmit}
      resident={resident}
      editedIndex={editedIndex}
      getNewContact={getNewContact}
      isLoading={isLoading}
      title={`${residentName} ${t(supConstants.PROFESSIONAL_CONTACT)}`}
    >
      <FormItem label={t(supConstants.ROLE)} name="relationship">
        <Select
          optionRender={(option) => <Text>{option.label}</Text>}
          showSearch
          options={sortedOptions}
          optionFilterProp="label"
        />
      </FormItem>
      <FormItem label={t(supConstants.ORGANISATION)} name="organisation">
        <Input />
      </FormItem>
      <FormItem label={t(supConstants.SPECIALITY)} name="speciality">
        <Input />
      </FormItem>
    </BaseContactForm>
  )
}

export default PersonalContactForm
